import { render, staticRenderFns } from "./ExtratoDetalhe.vue?vue&type=template&id=4c75106e&scoped=true"
import script from "./ExtratoDetalhe.vue?vue&type=script&lang=js"
export * from "./ExtratoDetalhe.vue?vue&type=script&lang=js"
import style0 from "./ExtratoDetalhe.vue?vue&type=style&index=0&id=4c75106e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75106e",
  null
  
)

export default component.exports